export default {"src":"/_next/static/media/url-doc.6b25dffc.svg","height":40,"width":40};